import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/**
 * SoulPathCard — a large editorial pathway card used on the Soul landing
 * page. Imagery occupies the upper 40%; copy sits below on a subtle cream
 * surface with a thin warm border. Not a SaaS feature card.
 */
export default function SoulPathCard({
  eyebrow,
  title,
  tagline,
  body,
  contains = [],
  image,
  to,
  testid,
}) {
  return (
    <Link
      to={to}
      data-testid={testid}
      className="group block relative overflow-hidden rounded-[24px] border transition-all duration-300 hover:-translate-y-[2px]"
      style={{
        borderColor: "hsl(var(--line))",
        background: "hsl(var(--paper))",
        boxShadow: "0 12px 32px -24px rgba(30,23,18,0.35)",
      }}
    >
      {/* Photograph — upper 40% */}
      <div
        className="relative aspect-[16/9] bg-center bg-cover"
        style={{ backgroundImage: `url("${image}")` }}
      >
        <div
          aria-hidden
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(180deg, rgba(30,23,18,0.10) 0%, rgba(30,23,18,0.35) 100%)",
          }}
        />
      </div>

      <div className="p-7 md:p-9">
        <div className="text-[11px] uppercase tracking-[0.28em] text-[hsl(var(--copper))]">
          {eyebrow}
        </div>
        <h3 className="font-display text-3xl md:text-4xl mt-3 tracking-tight text-[hsl(var(--fg))]">
          {title}
        </h3>
        <p className="font-display italic text-lg md:text-xl mt-3 text-[hsl(var(--clay))] leading-snug">
          {tagline}
        </p>
        <p className="mt-4 text-[15px] leading-relaxed text-[hsl(var(--fg))]/80 max-w-lg">
          {body}
        </p>

        {contains?.length > 0 && (
          <ul className="mt-6 flex flex-wrap gap-x-4 gap-y-2 text-[11px] uppercase tracking-[0.22em] text-[hsl(var(--muted-foreground))]">
            {contains.map((c) => (
              <li key={c} className="flex items-center gap-2">
                <span
                  aria-hidden
                  className="w-1 h-1 rounded-full bg-[hsl(var(--copper))]/60"
                />
                {c}
              </li>
            ))}
          </ul>
        )}

        <div className="mt-8 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-[hsl(var(--copper))]">
          <span>Explore</span>
          <ArrowRight
            size={14}
            className="transition-transform group-hover:translate-x-1"
          />
        </div>
      </div>
    </Link>
  );
}
